<template>
    <div class="performance-list" :class="classes">
        <div class="row">
            <template v-if="sidenav">
                <div class="col-12 col-lg-auto order-lg-1 mb-4 m-lg-0">
                    <button class="btn btn-link d-inline-block d-lg-none ml-n2" v-b-toggle.months>
                        Aller à...
                    </button>
                    <div class="position-sticky" style="top: 200px">
                        <b-collapse id="months" class="d-lg-block">
                            <hr class="d-lg-none">
                            <ul class="nav nav-pills flex-lg-column align-items-start mx-n2 mx-lg-0"  v-b-scrollspy="scrollspyOptions">
                                <template v-for="group in groupedPerformances">
                                    <li class="nav-item mb-1">
                                        <a class="nav-link px-1 text-uppercase" :href="`#${groupId(group)}`" @click.prevent="handleNavClicked">
                                            <span class="d-inline-block" style="min-width: 6.5em">
                                                {{ navTitle(group) }}
                                            </span>
                                        </a>
                                    </li>
                                </template>
                            </ul>
                        </b-collapse>
                    </div>
                </div>
            </template>
            <div class="col">
                <div style="max-width: 700px">
                    <template v-if="performances.length">
                        <template v-for="group in groupedPerformances">
                            <div class="performance-list__group" :key="group.date">
                                <template v-if="showMonths">
                                    <h2 :id="groupId(group)" class="performance-list__title performance-list__title--large">
                                        {{ groupTitle(group) }}
                                    </h2>
                                    <hr class="my-2">
                                </template>

                                <div class="list-group mx-n3 mx-sm-n2">
                                    <template v-for="performance in group.performances">
                                        <PerformanceItem
                                            :performance="performance"
                                            :audiences="audiences"
                                            :show-company="showCompany"
                                            :key="performance.id"
                                        />
                                    </template>
                                </div>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <em class="text-muted">
                            Aucun spectacle n'a été trouvé avec ces critères
                        </em>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import PerformanceItem from "./PerformanceItem";
import { VBScrollspy } from "bootstrap-vue";

export default {
        components: {
            PerformanceItem,
        },
        props: {
            performances: Array,
            audiences: Object,
            showMonths: {
                type: Boolean,
                default: true,
            },
            showCompany: {
                type: Boolean,
                default: true,
            },
            sidenav: Boolean,
        },
        computed: {
            groupedPerformances() {
                return Object.entries(
                    (this.performances||[])
                        .sort((a, b) => dayjs(a.starts_at).diff(b.starts_at))
                        .reduce((res, performance) => {
                            const key = dayjs(performance.starts_at).format('YYYY-MM');
                            return {
                                ...res,
                                [key]: [...(res[key] ?? []), performance]
                            }
                        }, {})
                )
                .map(([date, performances]) => ({
                    date,
                    performances,
                }))
                .sort((a, b) =>
                    a.date < b.date ? -1 : a.date > b.date ? 1 : 0
                );
            },
            classes() {
                return {
                    'performance-list--groups': this.showMonths,
                }
            },
            scrollspyOptions() {
                return {
                    offset: 200,
                }
            },
        },
        methods: {
            groupTitle(group) {
                return dayjs(group.date).format('MMMM YYYY');
            },
            navTitle(group) {
                return dayjs(group.date)
                    .format('MMM YYYY')
                    .replace('.', '');
            },
            groupId(group) {
                return `month-${group.date}`;
            },
            handleNavClicked(e) {
                const link = e.target.closest('a');
                const target = document.querySelector(link.getAttribute('href'));
                window.scrollBy(0, target.getBoundingClientRect().y - 180);
            },
        },
        directives: {
            'b-scrollspy': VBScrollspy,
        },
    }
</script>
